import dayjs from "dayjs";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { Text } from "@components/Text";

const Container = styled.div`
  width: 300px;
`;

const ContainerDayOfWeekList = styled.div`
  display: flex;
  gap: 14px;
  /* flex-direction: column; */
`;

export const ContentInfo = ({ data }) => {
  const startDate = _.get(data, ["start_date"]);
  const endDate = _.get(data, ["end_date"]);
  const startTime = _.get(data, ["start_time"]);
  const endTime = _.get(data, ["end_time"]);
  const dayOfWeeks = _.get(data, ["days_of_week"]);
  const width = _.get(data, ["width"]);
  const height = _.get(data, ["height"]);

  // const maxDuration = _.chain(data)
  //   .get(["adsBlocks"])
  //   .map((item) => {
  //     const blockMedias = _.get(item, ["blockMedias"]);
  //     return _.sumBy(blockMedias, "duration");
  //   })
  //   .max()
  //   .value();

  const isNoEnd = dayjs(endDate).isSame("3000-01-01", "day");

  return (
    <Container>
      <Text>
        Start date :{" "}
        {isNoEnd ? "Forever" : dayjs(startDate).format("YYYY-MM-DD")}
      </Text>
      <Text>
        End date : {isNoEnd ? "Forever" : dayjs(endDate).format("YYYY-MM-DD")}
      </Text>
      <Text>Start time : {startTime}</Text>
      <Text>End time : {endTime}</Text>
      <Text>Width : {width}px</Text>
      <Text>Height : {height}px</Text>
    </Container>
  );
};
